import React from 'react';

import { SvgWrapper } from 'components/svgs/SvgWrapper/SvgWrapper';

export const DownloadSvg = ({ ...svgProps }) => (
  <SvgWrapper viewBox="0 0 12 12" {...svgProps}>
    <path d="M6 1C6.27614 1 6.5 1.22386 6.5 1.5V6.79289L8.14645 5.14645C8.34171 4.95118 8.65829 4.95118 8.85355 5.14645C9.04882 5.34171 9.04882 5.65829 8.85355 5.85355L6.35355 8.35355C6.25669 8.45042 6.12996 8.49923 6.003 8.49999L6 8.5L5.997 8.49999C5.9303 8.4996 5.86669 8.48615 5.80861 8.46206C5.74964 8.43766 5.69439 8.40149 5.64645 8.35355L3.14645 5.85355C2.95118 5.65829 2.95118 5.34171 3.14645 5.14645C3.34171 4.95118 3.65829 4.95118 3.85355 5.14645L5.5 6.79289V1.5C5.5 1.22386 5.72386 1 6 1Z" />
    <path d="M1.5 10C1.22386 10 1 10.2239 1 10.5C1 10.7761 1.22386 11 1.5 11H10.5C10.7761 11 11 10.7761 11 10.5C11 10.2239 10.7761 10 10.5 10H1.5Z" />
  </SvgWrapper>
);
